import {SortingState} from '@tanstack/table-core';
import {MRT_ColumnSizingState} from 'material-react-table';
import React from 'react';
import Table from '@/components/table';
import useInvitedCreatorsColumns from '../../hooks/use-invited-creators-columns';
import type {InvitedCreatorRow} from '../../types/creatorTabTypes';

interface InvitedCreatorsTableProps {
  data: InvitedCreatorRow[];
  sorting: SortingState;
  onSorting: (sorting: SortingState) => void;
  onOpenProfile: (row: InvitedCreatorRow) => void;
  onEndReached?: () => void;
  isLoading?: boolean;
  emptyStateComponent?: React.ReactNode;
  columnSizing?: MRT_ColumnSizingState;
  onColumnSizingChange?: (sizing: MRT_ColumnSizingState) => void;
  showEmailColumn?: boolean;
  tableScrollTopKey?: string;
  visibleColumns?: Record<string, boolean>;
}

const EMPTY_VISIBLE_COLUMNS: Record<string, boolean> = {};
const EMPTY_ROW_SELECTION: Record<string, boolean> = {};
const EMPTY_COLUMN_SIZING: MRT_ColumnSizingState = {};

function InvitedCreatorsTable({
  data,
  sorting,
  onSorting,
  onOpenProfile,
  onEndReached,
  isLoading,
  emptyStateComponent,
  columnSizing = EMPTY_COLUMN_SIZING,
  onColumnSizingChange,
  showEmailColumn = false,
  tableScrollTopKey,
  visibleColumns = EMPTY_VISIBLE_COLUMNS,
}: InvitedCreatorsTableProps) {
  const columns = useInvitedCreatorsColumns({
    onOpenProfile,
    showEmailColumn,
  });

  return (
    <Table
      key={tableScrollTopKey}
      data={data}
      columns={columns}
      sorting={sorting}
      onSorting={onSorting}
      isLoadingInitial={isLoading && data.length === 0}
      showProgressBars={false}
      visibleColumns={visibleColumns}
      rowSelection={EMPTY_ROW_SELECTION}
      enableSorting
      enableVirtualization
      enableColumnResizing
      columnSizing={columnSizing}
      onColumnSizingChange={onColumnSizingChange}
      manualSorting
      onEndReached={onEndReached}
      tabIndex={0}
      emptyStateComponent={emptyStateComponent}
      tableScrollTopKey={tableScrollTopKey}
    />
  );
}

export default InvitedCreatorsTable;
